var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1303 63H51.9103V61.58C51.9103 59.1 52.8903 57.86 55.6503 56.92L58.8503 55.82C60.4503 55.24 61.0103 54.7 61.0103 53.52C61.0103 52.1 60.0903 51.38 57.6903 51.38C55.0103 51.38 54.0103 52.32 54.0103 54.08V54.32H51.8903V54.12C51.8903 51.64 53.5903 49.4 57.7703 49.4C61.5703 49.4 63.1703 51.2 63.1703 53.56C63.1703 55.76 61.7503 56.92 59.3903 57.64L56.5703 58.5C54.7703 59.12 54.1503 59.76 54.1503 61.28L57.3903 61.06H63.1303V63Z",
    fill: "#09041C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56.5,
    stroke: "#DDDFE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9998 57C93.9998 36.5655 77.4343 20 56.9998 20",
    stroke: "#FCE80F",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9998 94C77.4343 94 93.9998 77.4345 93.9998 57",
    stroke: "#FF6633",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 57C19.9998 77.4345 36.5652 94 56.9998 94",
    stroke: "#28DDCF",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9998 20C36.5652 20 19.9998 36.5655 19.9998 57",
    stroke: "#764AFF",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/number-2.b6fef2aef1c202bb8237f5f1bfcb77ca.svg";
export { ForwardRef as ReactComponent };